import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { ProjetoImpactoOrcamentarioService } from '../services/projeto-impacto-orcamentario.service';

@Injectable({
  providedIn: 'root',
})
export class ProjetoImpactoOrcamentarioResolver implements Resolve<boolean> {
  constructor(private service: ProjetoImpactoOrcamentarioService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getById(route.params.id);
  }
}
